import { useCallback } from 'react';
import useGridApi from 'common/providers/AgGridProvider/hooks/useGridApi';
import useGridLoading from 'common/providers/AgGridProvider/hooks/useGridLoading';
import useQueueData from 'features/queue/newGrid/hooks/useQueueData';

interface RefreshQueueParams {
    clearCache?: boolean;
    showLoader?: boolean;
}

const useRefreshQueue = (): (params?: RefreshQueueParams) => void => {
    const [gridApi] = useGridApi();
    const [,setIsLoading] = useGridLoading();
    const { removeQueueData } = useQueueData();

    return useCallback((params: RefreshQueueParams = {}) => {
        if (!gridApi.current?.refreshServerSide || gridApi.current?.isDestroyed?.()) {
            return;
        }

        const {
            clearCache = true,
            showLoader = true,
        } = params;

        if (clearCache) {
            removeQueueData();
        }

        setIsLoading(showLoader);
        gridApi.current.refreshServerSide();
    }, [gridApi, removeQueueData, setIsLoading]);
}

export default useRefreshQueue;